import axios from "axios";
import { API_ENDPOINT } from "../../apiConstant";
import { SAVE_USER_DETAIL, SAVE_DOCUMENT_STATUS } from "../../Redux/types";

export const saveUserDetail = (dispatch, data) => {
  dispatch({
    type: SAVE_USER_DETAIL,
    payload: data,
  });
};

export const saveDocumentStatus = (data) => {
  return (dispatch) => {
    dispatch({
      type: SAVE_DOCUMENT_STATUS,
      payload: data,
    });
  };
};

export const getUserDetail = (token) => {
  let url = `${API_ENDPOINT}/api/v2/general_user_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveUserDetail(dispatch, res.data);
          return resolve(res);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            return reject(error.response.status);
          }
        });
    });
};

export const getUserProfile = (data,token) => {
  let url = `${API_ENDPOINT}/api/presigned_url_user_image/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};


export const getWhatsappNumber = (token ) => {
  const url = `${API_ENDPOINT}/api/user_details/whatsapp_number/`;
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const updateWhatsappNumber = (whatsappNumber, token) => {
  // console.log(whatsappNumber, "wahataumber insideaction postapi");
  const url = `${API_ENDPOINT}/api/user_details/whatsapp_number/`;
  const Body = {
    "whatsapp_number": whatsappNumber,
  }
  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "application/json",
    },
  };

  return  (dispatch) => new Promise((resolve, reject) => {
    axios

      .post(url,Body, config)

      .then((res) => {
        return resolve(res.data);
      })

      .catch((err) => {
        return reject(err);
      });
  });
};

export const emailVerify = (params) => {
  let url = `${API_ENDPOINT}/api/authentication/email_verify/`;

  return  (dispatch) => new Promise((resolve, reject) => {
    axios

      .post(url, params)

      .then((res) => {
        // console.log(res,"kksadjfkh")
        return resolve(res.data);
      })

      .catch((err) => {
        return reject(err);
      });
  });
};

export const emailOtpVerify = (params) => {
  let url = `${API_ENDPOINT}/api/authentication/email_otp_verify_register/`;

  const receivedKey = localStorage.getItem("receivedKey");
  const payload = {
    ...params,
    ...(receivedKey && { source: "pl-landing" }),
  };

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload)
      .then((res) => {
        localStorage.setItem("access_token", res?.data?.data?.token);
        localStorage.setItem("access_refresh", res?.data?.data?.refresh);
        return resolve(res.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};


export const signInUser = (data) => {
  let url = `${API_ENDPOINT}/api/authentication/authenticate_mpin/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then((res) => {
          localStorage.setItem("gpay_token", res?.data?.data?.token);

          saveUserToken(dispatch, res?.data?.data);
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};









export const getGenralUserDetail = (token) => {
  let url = `${API_ENDPOINT}/api/v2/general_user_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          saveUserDetail(dispatch, res.data);
          return resolve(res);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            return reject(error.response.status);
          }
          // return reject(err)
        });
    });
};

export const getBlockedSections = (token) => {
  let url = `${API_ENDPOINT}/api/general_data/blocked_section/`;
  const config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            return reject(error.response.status);
          }
          return reject(error); 
        });
    });
};

export const checkBlockedEligibility = (token) => {
  let url = `${API_ENDPOINT}/api/general_data/check_blocked_eligibility/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
};

export const cibilPullOnReeligibility = (token) => {
  let url = `${API_ENDPOINT}/api/cibil_pull_on_reeligibility/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => resolve(res))
        .catch((error) => reject(error));
    });
};
export const getBasicDetails = (token) => {
  let url = `${API_ENDPOINT}/api/user_details/basic_details/`;
  let config = {
    headers: {
      Authorization: "Token " + token,
      "Content-Type": "application/json",
    },
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((error) => {
          return reject(error);
        });
    });
};

